// extracted by mini-css-extract-plugin
export default {"header_container":"header_header_container__6jB2M","shipment_button":"header_shipment_button__72+6f","header_logo":"header_header_logo__ce6+p"};